// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Y6PO3DDdkP2fnA {
  z-index: 10;
  margin: var(--ds-space-0, 0) var(--ds-space-025, 2px);
  border-radius: var(--ds-border-radius-400, 16px);
  background-color: var(--ds-surface-raised, #ffffff);
}
.Y6PO3DDdkP2fnA:hover {
  background-color: var(--ds-surface-raised-hovered, #f1f2f4);
}
.Y6PO3DDdkP2fnA:active {
  background-color: var(--ds-surface-raised-pressed, #dcdfe4);
}
.Y6PO3DDdkP2fnA > span > svg {
  width: 14px;
  height: 14px;
}
`, ""]);
// Exports
export var editButton = `Y6PO3DDdkP2fnA`;
export default ___CSS_LOADER_EXPORT___;
